import script from "./FirstLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstLogin.vue?vue&type=script&setup=true&lang=js"

import "./FirstLogin.vue?vue&type=style&index=0&id=23619bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23619bf2"]])

export default __exports__